import React from "react";
import { APPROVAL_STYLES, PRIORITY_STYLES, WORKFLOW_STATE_STYLES } from "@/lib/platform";

export const StateBadge = ({ state, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap ${
      WORKFLOW_STATE_STYLES[state] || "bg-slate-100 text-slate-600 border-slate-200"
    }`}
  >
    {state}
  </span>
);

export const PriorityBadge = ({ priority, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-semibold uppercase tracking-wide ${
      PRIORITY_STYLES[priority] || "bg-slate-100 text-slate-600"
    }`}
  >
    {priority}
  </span>
);

export const ApprovalBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold ${
      APPROVAL_STYLES[status] || ""
    }`}
  >
    {status}
  </span>
);

export const PageTitle = ({ eyebrow, title, subtitle, actions }) => (
  <div className="flex items-end justify-between flex-wrap gap-4">
    <div>
      <div className="text-xs font-mono text-slate-500 uppercase tracking-wide">{eyebrow}</div>
      <h1 className="text-3xl font-bold tracking-tight text-[#003366] mt-1">{title}</h1>
      {subtitle && <p className="text-sm text-slate-600 mt-1 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, hint, testId }) => (
  <div
    data-testid={testId}
    className="border border-dashed border-slate-300 rounded-xl bg-slate-50/60 py-14 flex flex-col items-center text-center"
  >
    {Icon && <Icon className="w-8 h-8 text-slate-400 mb-3" />}
    <div className="text-sm font-semibold text-[#003366]">{title}</div>
    {hint && <div className="text-xs text-slate-500 mt-1 max-w-sm">{hint}</div>}
  </div>
);
